export * from "./device-info";
export * from "./device-info.types";
